/**
 * How a figure in a table is shown, which is not always how it is stored.
 *
 * A printed statement writes a negative in brackets, `(1 467)`, where CSRD and
 * the importer hold `-1 467`. The table says which it wants (`look.negatives`),
 * and only what is drawn changes: the cell keeps its sign, so an export of the
 * data, a refresh from CSRD and the comparison that detects a change all still
 * see the figure as it was read. Nothing here is ever written back.
 *
 * Pure. A cell and a choice in, the words to draw out.
 */

import type { TableCell } from '@/domain/section'
import type { TableNegatives } from '@/sections/table/look'

/** A sign, then a figure: `-1 467`, `−295`, `- 18`, `-4,5`. The minus may be the true minus sign. */
const SIGNED = /^[-−]\s*(\d[\d\s  .,]*)$/

/** What a cell shows: a negative figure in brackets when asked, otherwise its own words. */
export function shownFigure(cell: TableCell, negatives: TableNegatives | undefined): string {
  if (negatives !== 'parentheses' || !cell.numeric) return cell.value
  const match = SIGNED.exec(cell.value.trim())
  return match ? `(${match[1]?.trim()})` : cell.value
}
